/* eslint-disable */
import React, { Component } from "react";
import { Form, Button, Grid, Input } from "semantic-ui-react";
import ErrorMsgLabel from "../shared/errorMsgLabel";
// import { DateInput } from 'semantic-ui-calendar-react';
import Select from "react-select";
import { selectFieldStyle } from "@utils/const";
import CustomSnackbar from "../shared/custom_snackbar";
import { removeAccents } from "@utils/stringUtil";
import { dateDividers, getTodayDate, lastDayOfTheMonth, reverseMaskDate } from "@utils/date";
import m from "@utils/strings";
import _ from "lodash";

class FormFiltro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateRange: "",
      dateFrom: reverseMaskDate(getTodayDate()),
      dateTo: reverseMaskDate(getTodayDate()),
      numeroCarteira: "",
      nomeBeneficiario: "",
      nomeProfissional: "",
      numeroGuia: "",
      isDateFromValid: true,
      isDateToValid: true,
      tipoGuiaSelecionada: { value: "", label: "" },
      snackBarMessage: "",
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.props.focusFirstField(this.focus);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && this.props.activeAccordion == "1") {
      event.preventDefault();
      this.handleSubmit();
    }
  }

  dateChange = (event, { name, value }) => {
    
    let temp = reverseMaskDate(value, dateDividers.DASH, dateDividers.BAR);
    let splitDate = temp.split("/");

    if (splitDate.length === 3) {
      if (parseInt(splitDate[1], 10) > 12) splitDate[1] = "1";

      if (
        splitDate[1].length > 0 &&
        parseInt(splitDate[0], 10) >
          lastDayOfTheMonth(parseInt(splitDate[1], 10))
      )
        splitDate[0] = "1";
      if (splitDate[2].length <= 4) {
        // value = splitDate[0] + "/" + splitDate[1] + "/" + splitDate[2];
        this.setState({ [name]: value });
      }
      if (
        splitDate[2].length === 4 &&
        new Date(`${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`) > new Date()
      ) {
        this.setState({
          snackBarMessage:
            m.TELA_GERACAO_LOTE_COBRANCA.NOTIFICACAO_DATA_INVALIDA,
        });
        this.exibirSnackBar();
        this.setState({ [name]: reverseMaskDate(getTodayDate()) });
      }
    } else if (splitDate.length > 3) {
    } else {
      this.setState({ [name]: value });
    }

    if (name == "dateFrom")
      if (!this.isDateValid(splitDate)) {
        this.setState({ isDateFromValid: false });
      } else {
        this.setState({ isDateFromValid: true });
      }
    else if (name == "dateTo")
      if (!this.isDateValid(splitDate)) {
        this.setState({ isDateToValid: false });
      } else {
        this.setState({ isDateToValid: true });
      }

    let formattedDateFrom = reverseMaskDate(this.state.dateFrom, dateDividers.DASH, dateDividers.BAR).split("/");
    let formattedDateTo = reverseMaskDate(this.state.dateTo, dateDividers.DASH, dateDividers.BAR).split("/");

    let tempDateFrom = new Date(
      `${formattedDateFrom[1]}/${formattedDateFrom[0]}/${formattedDateFrom[2]}`
    );
    let tempDateTo = new Date(
      `${formattedDateTo[1]}/${formattedDateTo[0]}/${formattedDateTo[2]}`
    );

    if (tempDateFrom > tempDateTo) {
      this.setState({
        snackBarMessage:
          m.TELA_REIMPRESSAO_GUIA.NOTIFICACAO_DATA_INICIAL_MAIOR_DATA_FINAL,
      });
      this.exibirSnackBar();
      this.setState({ dateFrom: this.state.dateTo });
    }
  };

  isDateValid = (date) => {
    if (date.length == 1 && _.isEmpty(date[0])) return true;
    if (_.isEmpty(date)) return true;
    if (
      date.length != 3 ||
      date[1].length === 0 ||
      date[0].length === 0 ||
      date[2].length === 0
    )
      return false;
    if (
      new Date(`${date[1]}/${date[0]}/${date[2]}`).toString() === "Invalid Date"
    )
      return false;
    return true;
  };

  handleInputStateValue = (event, { name, value }) => {
    if (name == "numeroCarteira" || name == "numeroGuia")
      value = value.replace(
        /([.*+?^=!:;>,<"'´`~&%$#@${}()|\[\]\\a-zA-Z\/\-])/g,
        ""
      );
    if (value.length > 17 && name == "numeroCarteira")
      value = value.substring(0, value.length - 1);
    if (value.length > 70 && name == "nomeBeneficiario")
      value = value.substring(0, value.length - 1);
    if (name == "nomeBeneficiario")
      this.setState({ nomeBeneficiarioSubmit: removeAccents(value) });
    this.setState({ [name]: value });
  };

  tipoGuiaSelect = (event) => {
    if (!_.isEmpty(event)) this.setState({ tipoGuiaSelecionada: event });
    else this.setState({ tipoGuiaSelecionada: { value: "", label: "" } });
  };

  handleSubmit = () => {
    let from = reverseMaskDate(this.state.dateFrom, dateDividers.DASH, dateDividers.BAR).split("/");
    let to = reverseMaskDate(this.state.dateTo, dateDividers.DASH, dateDividers.BAR).split("/");

    if (_.isEmpty(this.state.dateFrom) && _.isEmpty(this.state.dateTo)) {
      if (
        _.isEmpty(this.state.numeroCarteira) &&
        _.isEmpty(this.state.nomeBeneficiario) &&
        _.isEmpty(this.state.nomeProfissional) &&
        _.isEmpty(this.state.numeroGuia) &&
        _.isEmpty(this.state.tipoGuiaSelecionada)
      ) {
        this.props.applyFilter(null);
        return;
      }
    }
    if (from[2] && from[2].length < 4) {
      this.setState({ isDateFromValid: false });
      return;
    }
    if (
      new Date(`${from[1]}/${from[0]}/${from[2]}`).toString() ===
        "Invalid Date" &&
      !_.isEmpty(this.state.dateFrom)
    ) {
      this.setState({ isDateFromValid: false });
      return;
    } else {
      this.setState({ isDateFromValid: true });
    }

    if (to[2] && to[2].length < 4) {
      this.setState({ isDateToValid: false });
      return;
    }
    if (
      new Date(`${to[1]}/${to[0]}/${to[2]}`).toString() === "Invalid Date" &&
      !_.isEmpty(this.state.dateTo)
    ) {
      this.setState({ isDateToValid: false });
      return;
    } else {
      this.setState({ isDateToValid: true });
    }

    let buildFilterParams = {};
    if (!_.isEmpty(this.state.numeroCarteira))
      buildFilterParams.numeroCarteira = this.state.numeroCarteira;
    if (!_.isEmpty(this.state.nomeBeneficiarioSubmit))
      buildFilterParams.nomeBeneficiario = this.state.nomeBeneficiarioSubmit;
    if (
      !_.isEmpty(this.state.tipoGuiaSelecionada) &&
      !_.isEmpty(this.state.tipoGuiaSelecionada.label)
    )
      buildFilterParams.tipoGuia = this.state.tipoGuiaSelecionada.label;
    if (!_.isEmpty(this.state.numeroGuia))
      buildFilterParams.numeroGuia = this.state.numeroGuia;
    if (!_.isEmpty(this.state.dateFrom))
      buildFilterParams.periodoInicial = new Date(
        `${from[1]}/${from[0]}/${from[2]}`
      );
    if (!_.isEmpty(this.state.dateTo))
      buildFilterParams.periodoFinal = new Date(`${to[1]}/${to[0]}/${to[2]}`);

    this.props.applyFilter(buildFilterParams);
  };

  focus = () => {
    setTimeout(() => {
      if (this.textInput) this.textInput.focus();
    }, 1000);
  };

  render() {
    return (
      <div>
        <Form>
          <div id="label-buscar">
            {" "}
            {m.TELA_REIMPRESSAO_GUIA.LABEL_BUSCAR_POR}
          </div>
          <Form.Group id="form-group">
            <Form.Field inline={true} width={4}>
              <div className="form-input-label">
                {m.TELA_REIMPRESSAO_GUIA.LABEL_NUMERO_CARTEIRA}
              </div>
              <Input
                name="numeroCarteira"
                value={this.state.numeroCarteira}
                onChange={this.handleInputStateValue}
                ref={(input) => {
                  this.textInput = input;
                }}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_REIMPRESSAO_GUIA.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={4}>
              <div className="form-input-label">
                {m.TELA_REIMPRESSAO_GUIA.LABEL_NOME_BENEFICIARIO}
              </div>
              <Input
                name="nomeBeneficiario"
                value={this.state.nomeBeneficiario}
                onChange={this.handleInputStateValue}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_REIMPRESSAO_GUIA.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={4}>
              <div className="form-input-label">
                {m.TELA_REIMPRESSAO_GUIA.LABEL_TIPO_GUIA}
              </div>
              <Select
                name="tipoGuia"
                value={this.state.tipoGuiaSelecionada}
                onChange={this.tipoGuiaSelect}
                noOptionsMessage={({ inputValuetringrequired }) => {
                  return "";
                }}
                placeholder=""
                styles={selectFieldStyle}
                options={[
                  { value: "SP/SADT", label: "SP/SADT" },
                  { value: "CONSULTA", label: "CONSULTA" },
                ]}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_REIMPRESSAO_GUIA.LABEL_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field inline={true} width={4}>
              <div className="form-input-label">
                {m.TELA_REIMPRESSAO_GUIA.LABEL_NUMERO_GUIA}
              </div>
              <Form.Input
                name="numeroGuia"
                value={this.state.numeroGuia}
                onChange={this.handleInputStateValue}
              />
              <ErrorMsgLabel
                boolean={false}
                message={m.TELA_REIMPRESSAO_GUIA.LABEL_OBRIGATORIO}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group id="form-group">
            <Form.Field inline={true} width={4}>
              <div id="label-filtrar-periodo-tempo">
                {m.TELA_REIMPRESSAO_GUIA.LABEL_FILTRAR_POR_PERIODO_TEMPO}:
              </div>
            </Form.Field>
            <Form.Field inline={true} width={8}>
              <Grid columns="equal">
                <Grid.Column width={1}>
                  <div className="form-input-label date-from-label">
                    {" "}
                    {m.TELA_REIMPRESSAO_GUIA.LABEL_DE}{" "}
                  </div>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Input
                    type="date"
                    style={{ width: "100%" }}
                    name="dateFrom"
                    value={this.state.dateFrom}
                    onChange={this.dateChange}
                    className={this.state.isDateFromValid ? "" : "error"}
                    closable={true}
                    iconPosition="left"
                  />
                  <ErrorMsgLabel
                    boolean={!this.state.isDateFromValid}
                    message={m.TELA_REIMPRESSAO_GUIA.NOTIFICACAO_DATA_INVALIDA}
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                  <div className="form-input-label date-to-label">
                    {" "}
                    {m.TELA_REIMPRESSAO_GUIA.LABEL_A}{" "}
                  </div>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Input
                    type="date"
                    style={{ width: "100%" }}
                    name="dateTo"
                    value={this.state.dateTo}
                    onChange={this.dateChange}
                    className={this.state.isDateToValid ? "" : "error"}
                    closable={true}
                    iconPosition="left"
                  />
                  <ErrorMsgLabel
                    boolean={!this.state.isDateToValid}
                    message={m.TELA_REIMPRESSAO_GUIA.NOTIFICACAO_DATA_INVALIDA}
                  />
                </Grid.Column>
              </Grid>
            </Form.Field>
            <Form.Field inline={true} width={4}>
              <Button className="button-filtrar" onClick={this.handleSubmit}>
                {m.TELA_REIMPRESSAO_GUIA.LABEL_FILTRAR} (ENTER)
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <CustomSnackbar
          setClick={(click) => (this.exibirSnackBar = click)}
          variant="warning"
          duration={2000}
          content={this.state.snackBarMessage}
        />
      </div>
    );
  }
}

export default FormFiltro;
